import {
	IAudienceSegmentType,
	IAudienceSpecificType,
	IFilterType,
} from 'Components/flowChart/components/NodePreview/components/NodeYes/types';

export const FILTER_TYPE_LABEL: Record<IFilterType, string> = {
	customer_attribute: 'Customers',
	user_attribute: 'Visitors',
	item_segment: '',
	event_attribute: '',
};

export const SEGMENT_TYPE_LABEL: Record<IAudienceSegmentType | IAudienceSpecificType, string> = {
	customer_segment: 'customer',
	user_segment: 'visitor',
	customer_id: 'customer',
	user_id: 'visitor',
};
